import { ClerkProvider } from '@clerk/clerk-react';
import useLightMode from '../hooks/useLightMode';
import { clerkAppearance } from './clerkAppearance';

// Thin wrapper that reads our app's theme state and feeds it into Clerk's
// `appearance` prop. Lives below React's root because `useLightMode` (and its
// `use-dark-mode` dependency) need a render tree to hook into.
export default function ThemedClerkProvider({ publishableKey, children, ...rest }) {
    const { theme } = useLightMode();
    const isDark = theme === 'dark-mode';

    return (
        <ClerkProvider
            publishableKey={publishableKey}
            appearance={clerkAppearance(isDark)}
            {...rest}
        >
            {children}
        </ClerkProvider>
    );
}
